import Vue from 'vue'

const cache = new Map()
const inflight = new Map()

const TTL_MS = 10 * 1000

export function loadTemplate(path, params = {}) {
  const now = Date.now()

  if (cache.has(path)) {
    const { template, cachedAt } = cache.get(path)

    if (now - cachedAt < TTL_MS) {
      return Promise.resolve(template)
    }

    cache.delete(path)
  }

  if (inflight.has(path)) {
    return inflight.get(path)
  }

  const request = Vue.http
    .get(`templates${path}`, { params })
    .then(response => {
      const template = response?.data ?? ''

      cache.set(path, { template, cachedAt: Date.now() })
      return template
    })
    .finally(() => {
      inflight.delete(path)
    })

  inflight.set(path, request)
  return request
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/template.js